import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getLocale } from 'core/store/selectors/getLocale';
import { getUserNoteStatusPercent } from 'core/utils/user';
import { formatDisplayValue, useLocalizedInput } from 'core/utils/numericInputUtils';

export default function useInputPoints({ ariaLabel, props, max, onChange, colorsPoints, pointsTotal }) {
  const locale = useSelector(getLocale);
  const { t } = useTranslation();
  const effectiveMax = Number.isFinite(max) ? max : (Number.isFinite(pointsTotal) ? pointsTotal : undefined);

  const { value, setValue, hasError, onChangeText, onFocus, onBlur } = useLocalizedInput({
    initialValue: formatDisplayValue(props.value, locale),
    initialHasError: props.value > effectiveMax,
    locale,
    max: effectiveMax,
    onChange,
  });

  useEffect(() => {
    setValue(formatDisplayValue(props.value, locale));
  }, [props.value, locale]);

  const statusColor = useMemo(() => {
    let status = 'default';
    if (colorsPoints) {
      status = getUserNoteStatusPercent(props.value, pointsTotal);
    }

    return status;
  }, [pointsTotal, props.value, colorsPoints]);

  const accessibleName = ariaLabel || t('grades:Score out of total', { total: pointsTotal });

  return { accessibleName, value, hasError, onChangeText, onFocus, onBlur, statusColor, t };
}
